namespace $ {
	export let $mol_mem = $mol_wire_mem(0)
	export let $mol_mem_key = $mol_wire_mem(1)
	export let $mol_mem_key2 = $mol_wire_mem(2)
	export let $mol_mem_key3 = $mol_wire_mem(3)
}
